var _path, _circle, _line, _path2, _path3, _circle2, _circle3, _circle4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutubeAllTopIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 17,
    viewBox: "0 0 314 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.86396 1.13604L2.5 7.5L8.86396 13.864",
    stroke: "white",
    strokeWidth: 2.30687
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 232.206,
    cy: 6.83342,
    r: 4.58399,
    stroke: "white",
    strokeWidth: 1.53791
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 239.31,
    y1: 15.0242,
    x2: 234.722,
    y2: 10.436,
    stroke: "white",
    strokeWidth: 1.53791
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M279.037 3.03602L277.894 1.48047H273.323L272.18 3.03602H267.608V15.4805H283.608V3.03602H279.037Z",
    stroke: "white",
    strokeWidth: 1.53791,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M278.268 9.25803C278.268 10.9961 276.891 12.378 275.227 12.378C273.563 12.378 272.186 10.9961 272.186 9.25803C272.186 7.51991 273.563 6.1381 275.227 6.1381C276.891 6.1381 278.268 7.51991 278.268 9.25803Z",
    stroke: "white",
    strokeWidth: 1.53791
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 311.924,
    cy: 3.03791,
    r: 1.53791,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 311.924,
    cy: 8.1136,
    r: 1.53791,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 311.924,
    cy: 13.1898,
    r: 1.53791,
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeAllTopIcons);
export default __webpack_public_path__ + "static/media/youtubeAllTopIcons.5e7027b6.svg";
export { ForwardRef as ReactComponent };